export const enus = require("./enus.json");

